import waitFor from '@/js/helpers/wait-for';

const initSwipersFromFeatures = () =>
	waitFor(
		() => 'function' === typeof window.awc?.Swiper,
		() =>
			window.awcBlocksWithSwiperFeature.forEach(
				( settings ) => new window.awc.Swiper( settings )
			)
	);

if ( document.readyState === 'loading' ) {
	document.addEventListener( 'DOMContentLoaded', initSwipersFromFeatures );
} else {
	initSwipersFromFeatures();
}
